import { useLocation } from "react-router-dom";
import transicao from "../../../assets/transicao.png";
import imgHome from "../../../assets/banner-home.jpg";
import imgSobreNos from "../../../assets/banner-sobreNos.png";
import imgCastanha from "../../../assets/banner-castanha2.png";
import imgCaju from "../../../assets/banner-castanha1.png";
import imgProducao from "../../../assets/banner-producao.png";
import imgFaleConosco from "../../../assets/banner-faleConosco.jpg";
import imgReceitasSalgadas from "../../../assets/banner-receitasSalgadas.png";
import imgReceitasDoces from "../../../assets/banner-receitasDoces.png";

export default function Banner() {
  const location = useLocation();
  const path = location.pathname;

  const banners = {
    "/pt": {
      image: imgHome,
      alt: "Banner Home"
    },
    "/pt/sobre-nos": {
      image: imgSobreNos,
      alt: "Banner Sobre Nós"
    },
    "/pt/castanha": {
      image1: imgCaju,
      alt1: "Banner com Caju",
      image2: imgCastanha,
      alt2: "Banner com Castanha"
    },
    "/pt/producao": {
      image: imgProducao,
      alt: "Banner Sobre a Produção"
    },
    "/pt/fale-conosco": {
      image: imgFaleConosco,
      alt: "Banner Fale Conosco"
    },
    "/pt/receitas-salgadas": {
      image: imgReceitasSalgadas,
      alt: "Banner Receitas Salgadas"
    },
    "/pt/receitas-doces": {
      image: imgReceitasDoces,
      alt: "Banner Receitas Doces"
    },
    "/en": {
      image: imgHome,
      alt: "Home Banner"
    },
    "/en/about-us": {
      image: imgSobreNos,
      alt: "About Us Banner"
    },
    "/en/cashew": {
      image1: imgCaju,
      alt1: "Banner with the cashew fruit",
      image2: imgCastanha,
      alt2: "Banner with the cashew nut"
    },
    "/en/production": {
      image: imgProducao,
      alt: "About Production Banner"
    },
    "/en/contact-us": {
      image: imgFaleConosco,
      alt: "Contact Us Banner"
    },
    "/en/savory-recipes": {
      image: imgReceitasSalgadas,
      alt: "Savory Recipes Banner"
    },
    "/en/sweet-recipes": {
      image: imgReceitasDoces,
      alt: "Sweet Recipes Banner"
    }
  };

  const currentBanner = banners[path];

  // Se não houver banner definido para essa rota, não renderiza nada
  if (!currentBanner) return null;

  if (path === "/pt/castanha" || path === "/en/cashew") {
    return (
      <div className="banner-container">
        <div className="banner-castanha-container">
          <img src={currentBanner.image1} alt={currentBanner.alt1} />
          <img src={currentBanner.image2} alt={currentBanner.alt2} />
        </div>
        <img className="svg" src={transicao} alt="transicao svg" />
      </div>
    );
  }

  return (
    <div className="banner-container">
      <img
        className="banner-image"
        src={currentBanner.image}
        alt={currentBanner.alt}
      />
      <img className="svg" src={transicao} alt="transicao svg" />
    </div>
  );
}
